import {UPDATE_PERMISSIONS} from "../types";

export const updatePermissions = (permissions) => {
  return {
    type: UPDATE_PERMISSIONS,
    payload: {
        permissions
    },
  }
}